import { Bell, Mail, Smartphone } from "lucide-react";
import { RazorNumberFormat } from "../../../../components/razor-reuse";
import { NotificationChannelType } from "../../../../redux/type";

const STAT_ICON: Record<NotificationChannelType, React.ReactNode> = {
  email: <Mail className="size-[20px] text-[#734792]" />,
  push: <Bell className="size-[20px] text-[#734792]" />,
  in_app: <Smartphone className="size-[20px] text-[#734792]" />,
};

interface NotificationStatCardProps {
  icon: NotificationChannelType;
  label: string;
  value?: number;
  loading?: boolean;
}

export default function NotificationStatCard({
  icon,
  label,
  value,
  loading,
}: NotificationStatCardProps) {
  return (
    <div className="bg-white border-t-[3px] border-t-[#734792] border-x border-b border-[#E4E4E7] rounded-[8px] p-[20px]">
      <div className="flex items-center justify-center size-[40px] rounded-[8px] bg-[#F5F0FA]">
        {STAT_ICON[icon]}
      </div>
      <p className="text-[28px] font-bold text-[#1E1E1E] mt-[16px]">
        {loading
          ? "—"
          : RazorNumberFormat(value || 0, { hideDecimal: true, hideSymbol: true })}
      </p>
      <p className="text-[13px] text-[#758089] mt-[4px]">{label}</p>
    </div>
  );
}
